const GAME_DAY_UTC_OFFSET_MS = -2 * 60 * 60 * 1000;

/**
 * Ключ игрового дня 'YYYY-MM-DD'. Игровые сутки сменяются в 02:00 UTC
 * (05:00 по Москве): к моменту прибавляется смещение GAME_DAY_UTC_OFFSET_MS
 * (−2 часа), и день берется по UTC от сдвинутого времени. Это единая граница
 * для всех ежедневных механик — награда за вход, двойная награда за первый
 * рейтинговый матч дня, ежедневные кристаллы за рейтинг.
 * Принимает Date | timestamp | ISO-строку; null/undefined -> null.
 */
export const getGameDayKey = (dateInput) => {
  if (dateInput == null) return null;
  const timestamp = dateInput instanceof Date ? dateInput.getTime() : new Date(dateInput).getTime();
  if (Number.isNaN(timestamp)) return null;
  return new Date(timestamp + GAME_DAY_UTC_OFFSET_MS).toISOString().slice(0, 10);
};

/**
 * Момент начала следующих игровых суток после nowMs (timestamp, мс) — когда
 * снова станут доступны ежедневные награды (двойная награда за первый
 * рейтинговый матч дня и т.п.). Граница — та же, что у getGameDayKey.
 */
export const getNextGameDayStartMs = (nowMs) => {
  const shifted = new Date(nowMs + GAME_DAY_UTC_OFFSET_MS);
  const nextShiftedMidnight = Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate() + 1);
  return nextShiftedMidnight - GAME_DAY_UTC_OFFSET_MS;
};
